import { Breadcrumbs } from 'baseui/breadcrumbs';
import { StyledLink } from 'baseui/link';
import { LabelMedium } from 'baseui/typography';
import { useEffect, useMemo } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { currentPageState, pageState, previusPageState } from '../../../storage/app';
import { getPage, getPageTitle } from '../../../utils/pages';

export function PageTitle() {
  const { css } = useStyles();
  const pageId = useRecoilValue(pageState);
  const [previusPage, setPreviusPage] = useRecoilState(previusPageState);
  const [currentPage, setCurrentPagePath] = useRecoilState(currentPageState);
  const page = getPage(pageId);
  const title = getPageTitle(pageId);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (!currentPage?.path) {
      setCurrentPagePath((prev) => ({
        ...prev,
        path,
      }));
    } else {
      setPreviusPage(currentPage);
      setCurrentPagePath((prev) => ({
        ...prev,
        path,
      }));
    }
  }, [location]);

  useEffect(() => {
    setCurrentPagePath((prev) =>
      prev
        ? {
            ...prev,
            page,
          }
        : undefined,
    );
  }, [page]);

  const breadcrumbTitle = useMemo(() => {
    if (previusPage?.page) {
      return getPageTitle(previusPage.page.id);
    } else if (page?.breadcrumb) {
      return page.breadcrumb.title;
    }
    return '';
  }, [previusPage]);

  const navigationLink = useMemo(() => {
    if (previusPage?.page) {
      return generatePath(previusPage.path);
    } else if (page?.breadcrumb) {
      return generatePath(page.breadcrumb.defaultPath);
    }
    return '/';
  }, [previusPage]);

  if (!title) return <span className={css({ flex: 1 })} />;

  if (!page?.breadcrumb) return <LabelMedium marginRight={'auto'}>{title}</LabelMedium>;

  return (
    <Breadcrumbs>
      <StyledLink
        onClick={() => navigate(navigationLink)}
        className={css({ cursor: 'pointer' })}
      >
        {breadcrumbTitle}
      </StyledLink>
      <LabelMedium marginRight={'auto'}>{title}</LabelMedium>
    </Breadcrumbs>
  );
}
